/**
 * Quantity Guardian
 * =================
 * Enforces a maximum quantity for selected products in the cart.
 * Configure which products are restricted in Theme Settings →
 * Cart Quantity Limits → "Restricted products".
 *
 * Works with both native Shopify cart and UpCart.
 */

(function() {
  'use strict';

  /* Prevent double-injection */
  if (window.__PP_QTY_GUARDIAN_ACTIVE__) return;
  window.__PP_QTY_GUARDIAN_ACTIVE__ = true;

  /* ---- Read settings ---- */
  var RAW_HANDLES = ["5-free-party-patches-bach","free-gift-beach-ball","meta-funnel-wrapper-free-gift-instant-iv-x2","free-gift-instant-iv-x4","free-gift-koozie","free-gift-mystery-patch-pack","5-free-party-patches-onbrand"];
  var MAX_QTY = 1;
  var SHOW_TOAST = 'false' === 'true';

  var RESTRICTED_HANDLES = [];
  if (Array.isArray(RAW_HANDLES)) {
    RESTRICTED_HANDLES = RAW_HANDLES;
  }

  /* No restricted products → bail silently */
  if (RESTRICTED_HANDLES.length === 0) return;

  var restrictedHandleSet = {};
  RESTRICTED_HANDLES.forEach(function(h) {
    restrictedHandleSet[h.toLowerCase()] = true;
  });

  function isRestrictedProduct(handle) {
    if (!handle || typeof handle !== 'string') return false;
    return restrictedHandleSet[handle.toLowerCase()] === true;
  }

  /* ---- Core enforcement ---- */
  function enforceCart() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var updates = {};

        cart.items.forEach(function(item) {
          if (!isRestrictedProduct(item.handle)) return;

          if (item.quantity > MAX_QTY) {
            updates[item.key] = MAX_QTY;
          }
        });

        var keys = Object.keys(updates);
        if (keys.length > 0) {
          clearUpcartCache();
          applyUpdates(updates);
        }
      })
      .catch(function() {});
  }

  /* ---- Toast notification ---- */
  var toastTimer = null;
  var toastEl = null;

  function showToast() {
    var msg = MAX_QTY === 1
      ? 'Only 1 of this item allowed per order.'
      : 'Only ' + MAX_QTY + ' of this item allowed per order.';

    if (toastEl) {
      toastEl.textContent = msg;
      toastEl.style.opacity = '1';
      clearTimeout(toastTimer);
      toastTimer = setTimeout(hideToast, 3000);
      return;
    }

    toastEl = document.createElement('div');
    toastEl.setAttribute('role', 'alert');
    toastEl.textContent = msg;
    toastEl.style.cssText = [
      'position: fixed',
      'bottom: 20px',
      'left: 50%',
      'transform: translateX(-50%)',
      'z-index: 999999',
      'background: #d32f2f',
      'color: #fff',
      'padding: 14px 24px',
      'border-radius: 8px',
      'font-size: 15px',
      'font-weight: 600',
      'font-family: inherit',
      'box-shadow: 0 4px 20px rgba(0,0,0,0.3)',
      'max-width: 90vw',
      'text-align: center',
      'pointer-events: none',
      'transition: opacity 0.4s ease',
      'opacity: 1'
    ].join(';');
    document.body.appendChild(toastEl);
    toastTimer = setTimeout(hideToast, 3000);
  }

  function hideToast() {
    if (!toastEl) return;
    toastEl.style.opacity = '0';
    setTimeout(function() {
      if (toastEl && toastEl.parentNode) {
        toastEl.parentNode.removeChild(toastEl);
        toastEl = null;
      }
    }, 400);
  }

  /* ---- Apply updates with retry ---- */
  function applyUpdates(updates, attempt) {
    attempt = attempt || 0;
    if (attempt > 5) return;

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function() {
      if (SHOW_TOAST) showToast();
      if (typeof upcartRefreshCart === 'function') upcartRefreshCart();
      setTimeout(function() {
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var stillDirty = false;
            cart.items.forEach(function(item) {
              if (updates[item.key] !== undefined && item.quantity > MAX_QTY) {
                stillDirty = true;
              }
            });
            if (stillDirty) {
              clearUpcartCache();
              applyUpdates(updates, attempt + 1);
            }
          });
      }, 500);
    }).catch(function() {});
  }

  /* ---- Clear UpCart local cache ---- */
  function clearUpcartCache() {
    try {
      ['upcart_rewards', 'upcart_items', 'upcart_cart'].forEach(function(k) {
        localStorage.removeItem(k);
        sessionStorage.removeItem(k);
      });
    } catch(e) {}
  }

  /* ---- Intercept add-to-cart ---- */
  function interceptAddToCart() {
    var origFetch = window.fetch;
    if (!origFetch) return;

    window.fetch = function() {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');

      if (url.indexOf('/cart/add.js') === -1 || (args[1] && args[1].method && args[1].method !== 'POST')) {
        return origFetch.apply(window, args);
      }

      var body = args[1] ? args[1].body : null;
      if (!body) return origFetch.apply(window, args);

      var formData;
      if (typeof body === 'string') {
        try { formData = JSON.parse(body); } catch(e) { formData = null; }
      } else if (body instanceof FormData) {
        formData = {};
        body.forEach(function(v, k) { formData[k] = v; });
      }

      if (!formData) return origFetch.apply(window, args);

      var items = formData.items || [formData];
      var restrictedInPayload = false;
      items.forEach(function(item) {
        if (!item) return;
        if (isRestrictedProduct(item.handle || '')) {
          restrictedInPayload = true;
        }
      });

      if (!restrictedInPayload) {
        return origFetch.apply(window, args);
      }

      return origFetch.apply(window, args).then(function(response) {
        enforceCart();
        return response;
      }).catch(function() {
        enforceCart();
      });
    };
  }

  /* ---- Subscribe to UpCart events ---- */
  function connectUpcart() {
    if (typeof upcartSubscribeCartUpdated === 'function') {
      upcartSubscribeCartUpdated(function() { enforceCart(); });
    }
    if (typeof upcartSubscribeCartLoaded === 'function') {
      upcartSubscribeCartLoaded(function() { enforceCart(); });
    }
    if (typeof upcartSubscribeCartOpened === 'function') {
      upcartSubscribeCartOpened(function() { enforceCart(); });
    }
  }

  /* ---- Wait for UpCart API, with fallback polling ---- */
  function waitForUpcart(fn, timeoutMs) {
    var started = Date.now();
    function check() {
      if (typeof upcartSubscribeCartUpdated === 'function') {
        fn();
      } else if (Date.now() - started < timeoutMs) {
        setTimeout(check, 200);
      } else {
        startPolling();
      }
    }
    check();
  }

  /* ---- Fallback polling ---- */
  function startPolling() {
    setInterval(function() { enforceCart(); }, 2000);
  }

  /* ---- Boot ---- */
  interceptAddToCart();
  waitForUpcart(connectUpcart, 5000);
  setTimeout(enforceCart, 1000);
  document.addEventListener('cart:updated', function() { enforceCart(); });
  setInterval(function() { enforceCart(); }, 3000);

})();
